import { useState } from "react";
import {
  arrowdown,
  arrowup,
  logoutGray,
  menu,
  userProfilePicGold,
} from "assets/icons";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";

interface DashboardHeaderProps {
  activeSection?: string;
  setActiveSection: React.Dispatch<React.SetStateAction<string>>;
  setShowMobileAside: React.Dispatch<React.SetStateAction<boolean>>;
}

const DashboardHeader = ({
  activeSection,
  setActiveSection,
  setShowMobileAside,
}: DashboardHeaderProps) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const { loginData } = useSelector((state: RootState) => state.loginReducer);

  return (
    <header className="sticky top-0 z-20 px-[20px] md:px-[50px] w-full h-[85px] bg-white shadow-xl flex items-center justify-between">
      {/* the main title  ****************/}
      <div className="flex items-center gap-4">
        {/* menu icon  */}
        <div>
          <img
            onClick={() => setShowMobileAside(true)}
            className="w-[25px] md:hidden"
            src={menu}
            alt=""
          />
        </div>
        <div className="hidden md:block font-[500] lg:text-[20px]">
          {activeSection === "Profile"
            ? "My Profile"
            : activeSection === "OrphanDonationHistory"
            ? "Orphan Donation History"
            : activeSection === "ProjectsDonationHistory"
            ? "Projects Donation History"
            : activeSection === "GeneralDonationHistory"
            ? "General Donation History"
            : activeSection === "OrphanSponsorshipReport"
            ? "Orphan Sponsorship Report"
            : activeSection === "ExternalProjectsReports"
            ? "External Projects Reports"
            : ""}
        </div>
      </div>

      <div
        onClick={() => setShowDropdown(!showDropdown)}
        className="relative flex items-center gap-2 "
      >
        {/* user name  *******************/}
        <div className="flex flex-col items-end">
          <p className="font-[500] lg:text-[16px] cursor-pointer ">
            Hi, {loginData?.user?.full_name}
          </p>
        </div>

        {/* pic section  *****************/}
        <div className="w-[40px] h-[40px] flex items-center justify-center rounded-full cursor-pointer">
          <img src={userProfilePicGold} alt="" />
        </div>
        {/* arrow section  ***************/}
        <div>
          {showDropdown ? (
            <img className="w-[20px] cursor-pointer" src={arrowup} alt="" />
          ) : (
            <img className="w-[20px] cursor-pointer" src={arrowdown} alt="" />
          )}
        </div>

        {/* dropdown section *******/}
        {showDropdown && (
          <div
            className={`w-[260px] p-[18px] absolute top-[148%]  bg-white rounded-[20px] border shadow-shadow_main ${
              i18n.language === "en" ? "right-[0%] " : "left-[20%] "
            }`}
          >
            {/* upper section  ******************************/}
            <div className="flex items-center gap-[10px] pb-[15px] border-b-[1px]">
              <img
                className="w-[48px] min-w-[48px]"
                src={userProfilePicGold}
                alt=""
              />

              <div className="flex flex-col gap-[3px]">
                <p
                  className={`font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[600] text-[16px] text-[#444444]`}
                >
                  {loginData?.user?.full_name}
                </p>
                <p
                  onClick={() => setActiveSection("Profile")}
                  className={`font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[400] text-[16px] text-[#808184] hover:text-first_color/75 duration-300 cursor-pointer`}
                >
                  My Profile
                </p>
              </div>
            </div>

            {/* lower section  ******************************/}
            <div className="flex flex-col gap-[8px] pt-[15px]">
              <div
                onClick={() => {
                  dispatch({ type: "LOG_OUT" });
                }}
                className="flex items-center gap-[5px] "
              >
                <img
                  className="w-[20px] min-w-[20px]"
                  src={logoutGray}
                  alt=""
                />
                <p
                  className={`font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[600] text-[16px] text-[#808184] hover:text-first_color/75 duration-300 cursor-pointer`}
                >
                  {t("Logout")}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default DashboardHeader;
